import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ExceptionsSmallFill = (props: SvgIconT.Props) => (
  <SvgIcon width={12} height={13} {...props} viewBox="0 0 12 13">
    <g transform="translate(-1756.000000, -107.000000)">
      <path d="M1762,107.5 C1765.31371,107.5 1768,110.186292 1768,113.5 C1768,116.813708 1765.31371,119.5 1762,119.5 C1758.68629,119.5 1756,116.813708 1756,113.5 C1756,110.186292 1758.68629,107.5 1762,107.5 Z"></path>
    </g>
  </SvgIcon>
);

export default ExceptionsSmallFill;
